import PropTypes from 'prop-types'
import {Map} from 'immutable'

import AdvisorDetailsSubContent from './AdvisorDetailsSubContent'
import defaultAvatar from '../../../../../shared_assets/default-advisor-avatar.svg'

import {advisorContactCardImage} from '../../../../../lib/advisorContactCardTools'

import './advisorDetails.scss'

const AdvisorDetails = ({advisorContactCard}) => (
  <div className='advisor-details flex-child flex-container'>
    <img
      alt='Advisor image'
      className='flex-child'
      src={advisorContactCardImage({advisorContactCard, defaultImage: defaultAvatar})}
    />
    <AdvisorDetailsSubContent advisorContactCard={advisorContactCard} />
  </div>
)

AdvisorDetails.propTypes = {
  advisorContactCard: PropTypes.instanceOf(Map)
}

export default AdvisorDetails
